import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useConfirmUnsaved } from 'hooks/useConfirm';
import { Card } from 'components/Card';
import { TextAreaField } from 'components/Field/TextAreaField/TextAreaField';
import { doAseUnapprove, NAVIGATE_MODAL_BACK } from 'store/actions';
import { useEsc } from 'hooks/useEsc';
import { PageHeader } from 'components/PageHeader';

export const StatusUnapproveModal: React.FC<
  ModalScreenProps<ModalScreens.AseStatusUnapprove>
> = ({ navigation }) => {
  const dispatch = useDispatch();
  const confirmUnsaved = useConfirmUnsaved();

  const [note, setNote] = React.useState('');

  const handleClose = () => {
    if (note) {
      confirmUnsaved({
        onSave: handleSave,
        onDiscard: () => dispatch(NAVIGATE_MODAL_BACK()),
      });
      return;
    }
    dispatch(NAVIGATE_MODAL_BACK());
  };

  const handleSave = () =>
    dispatch(
      doAseUnapprove({
        note,
      }),
    );

  React.useEffect(() => {
    navigation?.setOptions({ gestureEnabled: !note });
  }, [navigation, note]);
  useEsc(handleClose);

  return (
    <Page
      scrollView
      header={
        <PageHeader
          title="Assessment"
          onPressCancelButton={handleClose}
          onPressSaveButton={note.trim() ? handleSave : null}
          saveButtonText="Unapprove"
        />
      }
    >
      <Card
        label="Reason"
        required
        explanation="Explain why you're unapproving this assessment. Your reason will be displayed in the assessment's history"
      >
        <TextAreaField onChange={setNote} value={note} onEsc={handleClose} />
      </Card>
    </Page>
  );
};
